import React, { Component } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../translations";

class ServiceOne extends Component{
    static contextType = LanguageContext;

    render(){
        const { language } = this.context;
        const t = translations[language];

        const ServiceList = [
            {
                icon: '01',
                title: t.homepage.slider.services ? t.homepage.slider.services[0].title : 'FinTech Solutions',
                description: t.homepage.slider.services ? t.homepage.slider.services[0].description : 'Secure payment systems, digital banking platforms, and compliance-ready financial applications built for scale.'
            },
            {
                icon: '02',
                title: t.homepage.slider.services ? t.homepage.slider.services[1].title : 'Web Development',
                description: t.homepage.slider.services ? t.homepage.slider.services[1].description : 'High-performance web applications with modern frameworks, cloud architecture, and responsive design.'
            },
            {
                icon: '03',
                title: t.homepage.slider.services ? t.homepage.slider.services[2].title : 'UI/UX Design',
                description: t.homepage.slider.services ? t.homepage.slider.services[2].description : 'User-centered interfaces optimized for conversion, accessibility, and Arabic market expertise.'
            },
        ];

        return(
            <React.Fragment>
                <div className="row">
                    {ServiceList.map( (val , i) => (
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                            <div className="service service__style--1">
                                <div className="icon">
                                    <img src={`/assets/images/icons/icon-${val.icon}.png`} alt="Digital Agency"/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{val.title}</h4>
                                    <p>{val.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceOne;